import {NEWS_IMG} from '../actions/types'
import {NEWS_IMG_CLOSE} from '../actions/types'



const INITIAL_STATE={
    news:'',
    CloseImgGallery:'none'
}

export default (state=INITIAL_STATE ,action)=>{
    switch (action.type) {
            case NEWS_IMG:
            return{
                ...state,
                news:action.payload,
                CloseImgGallery:'flex'
            }
            case NEWS_IMG_CLOSE:
            return{
                ...state,
                news:'',
                CloseImgGallery:'none'
            }
        default:
            return state;
    }
}







